(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["academy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mounted = new WeakMap();
    const str = value => typeof value === 'string' ? value : '';
    const rows = value => Array.isArray(value) ? value : [];
    function element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = String(text);
      return node;
    }
    function append(parent, ...children) {
      children.filter(Boolean).forEach(child => parent.append(child));
      return parent;
    }
    function link(label, href, className) {
      const node = element('a', className, label);
      node.href = href;
      return node;
    }
    function arrow() {
      const node = element('span', 'ps-a-arrow', '→');
      node.setAttribute('aria-hidden', 'true');
      return node;
    }
    function button(label, fn, outline = false) {
      const node = element('button', 'ps-a-button' + (outline ? ' ps-a-button-outline' : ''), label);
      node.type = 'button';
      node.addEventListener('click', fn);
      return node;
    }
    function safeUrl(value) {
      if (!str(value)) return null;
      try {
        const url = new URL(value, window.location.origin);
        return url.protocol === 'https:' && !url.username && !url.password ? url : null;
      } catch { return null; }
    }
    function imageNode(src, alt, className, position, eager = false) {
      const img = element('img', className);
      const url = safeUrl(src);
      if (url) img.src = url.href;
      img.alt = str(alt);
      img.loading = eager ? 'eager' : 'lazy';
      img.decoding = 'async';
      if (eager) img.fetchPriority = 'high';
      if (str(position) && /^(?:center|top|bottom|left|right|\d{1,3}(?:\.\d+)?%)(?:\s+(?:center|top|bottom|left|right|\d{1,3}(?:\.\d+)?%))?$/.test(position)) img.style.objectPosition = position;
      return img;
    }
    function initialise(root) {
      if (mounted.has(root)) return;
      const controller = new AbortController();
      mounted.set(root, controller);
      const view = root.querySelector('[data-academy-view]');
      let messages = {};
      try { messages = JSON.parse(root.querySelector('[data-academy-i18n]').textContent); } catch { return; }
      const t = (key, values = {}) => {
        let value = str(messages[key]);
        Object.entries(values).forEach(([name, replacement]) => { value = value.replaceAll('[' + name + ']', String(replacement)); });
        return value;
      };
      const preview = root.dataset.preview === 'true';
      const proxy = str(root.dataset.proxy).replace(/\/$/, '');
      let catalog = null;
      let fieldCounter = 0;
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: Number.isInteger(value) ? 0 : 2, maximumFractionDigits: 2 }).format(value);
      const route = (...parts) => '#' + parts.map(part => encodeURIComponent(part)).join('/');
      const courseBySlug = slug => catalog.courses.find(course => course.slug === slug);
      const tutorBySlug = slug => catalog.tutors.find(tutor => tutor.slug === slug);
      const previewCourse = course => preview || course.isPrototype === true;
      const sessionFull = session => session.status === 'waitlist' || session.placesLeft === 0;
      const canBook = (course, session) => !sessionFull(session) && (preview || (catalog.bookingsEnabled === true && !course.isPrototype && session.canBook === true));
      const friendAvailable = (course, session) => course.friendOfferEnabled !== false && (preview || session.friendOfferAvailable === true);
      function focus(node, scroll = true) {
        if (!node) return;
        node.tabIndex = -1;
        node.focus({ preventScroll: true });
        if (scroll) node.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
      function heading(text, eyebrow) {
        return append(element('div', 'ps-a-page-heading'), eyebrow && element('p', 'ps-a-eyebrow', eyebrow), element('h2', 'ps-a-page-title ps-a-scroll-target', text));
      }
      function note(text) { return element('p', 'ps-a-note', text); }
      function prose(value) {
        const container = element('div', 'ps-a-prose');
        str(value).split(/\n\s*\n/).filter(Boolean).forEach(text => container.append(element('p', '', text)));
        return container;
      }
      function list(values) {
        const ul = element('ul');
        rows(values).filter(value => typeof value === 'string').forEach(value => ul.append(element('li', '', value)));
        return append(element('div', 'ps-a-prose'), ul);
      }
      function details(title, content) {
        return append(element('details', 'ps-a-accordion'), element('summary', '', title), content);
      }
      function breadcrumb(course) {
        return link(t(course ? 'back_course' : 'back_courses'), course ? route('course', course.slug) : '#courses', 'ps-a-breadcrumb');
      }
      function card(course) {
        const node = link('', route('course', course.slug), 'ps-a-card');
        const image = append(element('div', 'ps-a-card-image'), imageNode(course.image, course.imageAlt, '', course.imagePosition), element('span', 'ps-a-category', course.category));
        const price = append(element('div'), element('small', '', previewCourse(course) ? t('preview_label') : t('from_price')), element('strong', '', money(course.price)));
        const meta = append(element('div', 'ps-a-card-meta'), element('span', '', course.duration), price);
        append(node, image, element('h3', '', course.title), element('p', 'ps-a-tutor-line', t('with_tutor', { name: course.tutorName })), element('p', 'ps-a-card-description', str(course.description).split(/\n\s*\n/)[0]), meta, append(element('span', 'ps-a-card-cta'), element('span', '', t('view_dates')), arrow()));
        return node;
      }
      function cards(courses) { return append(element('div', 'ps-a-grid'), ...courses.map(card)); }
      function sectionHeading(title, eyebrow, intro) {
        return append(element('div', 'ps-a-heading'), append(element('div'), element('p', 'ps-a-eyebrow', eyebrow), element('h2', 'ps-a-scroll-target', title)), intro && element('p', '', intro));
      }
      function tutorRow(tutor) {
        const avatar = element('span', 'ps-a-avatar', tutor.image ? '' : tutor.initials);
        if (tutor.image) avatar.append(imageNode(tutor.image, '', ''));
        const course = catalog.courses.find(item => item.tutorSlug === tutor.slug);
        const copy = append(element('div'), element('h3', '', tutor.name), tutor.affiliation && element('p', '', tutor.affiliation), course && element('p', '', course.shortTitle));
        return append(link('', route('tutor', tutor.slug), 'ps-a-tutor-row'), avatar, copy, arrow());
      }
      function home() {
        const fragment = document.createDocumentFragment();
        const hero = element('div', 'ps-a-hero ps-a-section');
        const intro = append(element('div'), preview && note(t('preview_note')), element('p', 'ps-a-eyebrow', t('eyebrow')), element('h2', 'ps-a-hero-title ps-a-scroll-target', t('hero_title')), element('p', 'ps-a-intro', t('hero_intro')), append(element('div', 'ps-a-actions'), append(link(t('explore'), '#courses', 'ps-a-button'), arrow()), link(t('meet_tutors'), '#tutors', 'ps-a-text-link')));
        hero.append(intro);
        const featured = catalog.courses[0];
        if (featured) {
          const session = rows(featured.sessions).find(item => !sessionFull(item));
          const date = append(element('div', 'ps-a-feature-date'), append(element('div'), element('small', '', previewCourse(featured) ? t('preview_label') : t('next_available')), element('strong', '', session ? session.displayDate : t('new_dates'))), arrow());
          const copy = append(element('div', 'ps-a-feature-copy'), element('span', 'ps-a-eyebrow', t('featured')), element('h3', '', featured.title), element('p', '', t('with_tutor', { name: featured.tutorName })), date);
          hero.append(append(link('', route('course', featured.slug), 'ps-a-feature'), imageNode(featured.image, featured.imageAlt, '', featured.imagePosition, true), copy));
        }
        const courseSection = append(element('div', 'ps-a-section ps-a-divider ps-a-scroll-target'), sectionHeading(t('courses'), t('choose_day'), t('courses_intro')), catalog.courses.length ? cards(catalog.courses) : element('p', 'ps-a-muted', t('empty_courses')));
        courseSection.dataset.focus = 'courses';
        const gift = append(link('', '#gifts', 'ps-a-utility'), element('span', 'ps-a-eyebrow', t('gift_eyebrow')), element('h3', '', t('gift_title')), element('p', '', t('gift_copy')));
        const privateCourse = append(link('', '#private', 'ps-a-utility ps-a-utility-dark'), element('span', 'ps-a-eyebrow', t('private_eyebrow')), element('h3', '', t('private_courses')), element('p', '', t('private_intro')));
        const tutors = append(element('div', 'ps-a-section ps-a-scroll-target'), sectionHeading(t('tutor_title'), t('tutor_eyebrow'), t('tutor_intro')), ...catalog.tutors.map(tutorRow));
        tutors.dataset.focus = 'tutors';
        append(fragment, hero, courseSection, append(element('div', 'ps-a-utilities'), gift, privateCourse), tutors);
        return fragment;
      }
      function coursePage(course) {
        const fragment = document.createDocumentFragment();
        const summary = append(element('div'), previewCourse(course) && note(t('sample_note')), element('p', 'ps-a-eyebrow', course.category), element('h2', 'ps-a-detail-title ps-a-scroll-target', course.title), append(element('p', 'ps-a-tutor-line'), link(t('with_tutor', { name: course.tutorName }), route('tutor', course.tutorSlug), 'ps-a-text-link')), element('p', 'ps-a-intro', str(course.description).split(/\n\s*\n/)[0]));
        const facts = element('dl', 'ps-a-facts');
        [['duration', course.duration], ['location', course.location], ['level', course.level], ['group_size', course.groupSize]].forEach(([key, value]) => facts.append(append(element('div'), element('dt', '', t(key)), element('dd', '', value))));
        append(summary, facts, append(element('div', 'ps-a-price'), element('strong', '', money(course.price)), element('span', '', t('per_person'))));
        const panel = append(element('aside', 'ps-a-panel ps-a-scroll-target'), element('h3', '', t('choose_date')));
        const dateHeading = panel.querySelector('h3');
        dateHeading.className = 'ps-a-scroll-target';
        append(summary, append(element('div', 'ps-a-actions'), button(t('choose_date'), () => focus(dateHeading))));
        if (previewCourse(course)) panel.append(note(t('example_dates')));
        else if (!catalog.bookingsEnabled) panel.append(note(t('booking_soon')));
        rows(course.sessions).forEach(session => {
          const bookable = canBook(course, session);
          const url = bookable ? route('book', course.slug, session.id) : route('waitlist', course.slug, session.id);
          let availability = sessionFull(session) ? t('full') : t('available');
          if (preview && Number.isInteger(session.placesLeft)) availability = t('places_left', { count: session.placesLeft });
          const copy = append(element('div'), element('strong', '', session.displayDate), element('small', '', session.time), element('small', '', availability));
          const action = element('span', 'ps-a-session-action', t(bookable ? (preview ? 'preview_booking' : 'book_place') : 'join_waitlist'));
          panel.append(append(link('', url, 'ps-a-session'), copy, action));
        });
        if (!rows(course.sessions).length) append(panel, element('p', 'ps-a-muted', t('new_dates')), append(element('div', 'ps-a-actions'), link(t('join_waitlist'), route('waitlist', course.slug), 'ps-a-button')));
        if (rows(course.sessions).some(session => friendAvailable(course, session))) panel.append(append(element('div', 'ps-a-friend'), element('strong', '', t('friend_title')), element('p', '', t('friend_copy'))));
        const information = append(element('div'), details(t('about_course'), prose(course.description)), details(t('outcomes'), list(course.outcomes)), details(t('included'), list(course.included)), details(t('suitable'), prose(course.suitableFor)));
        if (course.bookingTerms) information.append(details(t('terms'), prose(course.bookingTerms)));
        append(fragment, breadcrumb(), append(element('div', 'ps-a-detail'), imageNode(course.image, course.imageAlt, 'ps-a-detail-image', course.imagePosition, true), summary), append(element('div', 'ps-a-content-grid'), information, panel));
        return fragment;
      }
      function tutorPage(tutor) {
        const fragment = document.createDocumentFragment();
        const portrait = element('div', 'ps-a-portrait', tutor.image ? '' : tutor.initials);
        if (tutor.image) portrait.append(imageNode(tutor.image, tutor.name, '', '', true));
        const copy = append(element('div'), heading(tutor.name, t('meet_tutors')), tutor.affiliation && element('p', 'ps-a-muted', tutor.affiliation), element('p', 'ps-a-intro', tutor.introduction), append(element('div', 'ps-a-actions'), ...rows(tutor.links).map(item => {
          const url = safeUrl(item.url);
          if (!url) return null;
          const node = link(item.label, url.href, 'ps-a-text-link');
          node.target = '_blank';
          node.rel = 'noopener noreferrer';
          return node;
        })));
        append(fragment, breadcrumb(), append(element('div', 'ps-a-detail'), copy, portrait), append(element('div', 'ps-a-section ps-a-divider'), sectionHeading(t('approach'), t('meet_tutors')), prose(tutor.approach)), append(element('div', 'ps-a-section ps-a-divider'), sectionHeading(t('teaches'), tutor.name), cards(catalog.courses.filter(course => course.tutorSlug === tutor.slug))));
        return fragment;
      }
      function field(form, label, name, type, required = false, placeholder = '') {
        const id = root.id + '-field-' + (++fieldCounter);
        const wrapper = element('div', 'ps-a-field');
        const caption = element('label', '', label);
        caption.htmlFor = id;
        const input = element(type === 'textarea' ? 'textarea' : type === 'select' ? 'select' : 'input');
        if (!['textarea', 'select'].includes(type)) input.type = type;
        input.name = name;
        input.id = id;
        input.required = required;
        if (placeholder) input.placeholder = placeholder;
        if (type === 'textarea') input.maxLength = 5000;
        if (type === 'email') { input.maxLength = 254; input.autocomplete = 'email'; }
        if (name === 'name') { input.maxLength = 150; input.minLength = 2; input.autocomplete = 'name'; }
        if (name === 'phone') { input.maxLength = 100; input.autocomplete = 'tel'; }
        append(form, append(wrapper, caption, input));
        return input;
      }
      function checkbox(form, text, name) {
        const label = element('label', 'ps-a-check');
        const input = element('input');
        input.type = 'checkbox'; input.name = name; input.required = true;
        form.append(append(label, input, element('span', '', text)));
        return input;
      }
      async function api(path, body) {
        if (preview || !/^\/apps\/[a-z0-9][a-z0-9/_-]*$/i.test(proxy)) throw new Error(t('submit_error'));
        const timer = new AbortController();
        const timeout = window.setTimeout(() => timer.abort(), 20000);
        const signal = AbortSignal.any([controller.signal, timer.signal]);
        try {
          const response = await fetch(proxy + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
          const result = await response.json();
          if (!response.ok) throw new Error(str(result.error) || t('submit_error'));
          return result;
        } finally { window.clearTimeout(timeout); }
      }
      function formsPage(kind, course, session) {
        const title = t(kind === 'waitlist' ? 'waitlist_title' : kind === 'tutor' ? 'tutor_apply_title' : 'private_title');
        const intro = t(kind === 'waitlist' ? 'waitlist_intro' : kind === 'tutor' ? 'tutor_apply_intro' : 'private_intro');
        const introBox = append(element('div'), heading(title), element('p', 'ps-a-intro', intro));
        if (course) append(introBox, element('p', 'ps-a-intro', course.title), session && element('p', 'ps-a-muted', session.displayDate + ', ' + session.time));
        const form = element('form', 'ps-a-form ps-a-panel');
        form.method = 'post';
        if (preview) form.append(note(t('form_preview')));
        else if (!catalog.formsEnabled) form.append(note(t('form_disabled')));
        field(form, t('name_label'), 'name', 'text', true);
        field(form, t('email_label'), 'email', 'email', true);
        if (kind !== 'waitlist') {
          field(form, t('phone_label'), 'phone', 'tel');
          field(form, t('message_label'), 'message', 'textarea', true, t(kind === 'tutor' ? 'tutor_placeholder' : 'private_placeholder'));
        }
        const honeypot = field(form, t('website_label'), 'website', 'text');
        honeypot.parentElement.className = 'ps-a-honeypot'; honeypot.tabIndex = -1; honeypot.autocomplete = 'off';
        checkbox(form, t('consent'), 'consent');
        const error = element('p', 'ps-a-error'); error.setAttribute('role', 'alert'); error.hidden = true;
        const submit = element('button', 'ps-a-button', t(kind === 'waitlist' ? 'submit_waitlist' : kind === 'tutor' ? 'send_application' : 'send_enquiry'));
        submit.type = 'submit'; submit.disabled = !preview && (!catalog.formsEnabled || !catalog.csrfToken);
        append(form, error, submit);
        let pending = false;
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (pending || !form.reportValidity()) return;
          error.hidden = true;
          if (preview) {
            const result = append(element('div', 'ps-a-success'), element('h3', '', t('form_preview_success')), element('p', '', t('form_preview')), append(element('div', 'ps-a-actions'), link(t('continue_browsing'), '#courses', 'ps-a-button')));
            form.replaceChildren(result); focus(result.querySelector('h3')); return;
          }
          if (!catalog.formsEnabled || !catalog.csrfToken) return;
          pending = true; submit.disabled = true; submit.textContent = t('sending');
          try {
            const data = Object.fromEntries(new FormData(form));
            const payload = { ...data, kind, consent: true, csrfToken: catalog.csrfToken };
            if (course) payload.course = course.slug;
            if (session) payload.session = session.id;
            const response = await api(kind === 'waitlist' ? '/waiting-list' : '/enquiries', payload);
            const result = append(element('div', 'ps-a-success'), element('h3', '', t(kind === 'waitlist' ? 'waitlist_success' : 'enquiry_success')));
            const leaveUrl = safeUrl(response.leaveUrl);
            if (kind === 'waitlist' && leaveUrl) result.append(link(t('leave_waitlist'), leaveUrl.href, 'ps-a-text-link'));
            result.append(append(element('div', 'ps-a-actions'), link(t('continue_browsing'), '#courses', 'ps-a-button')));
            form.replaceChildren(result); focus(result.querySelector('h3'));
          } catch (failure) {
            error.textContent = failure instanceof Error && failure.name !== 'AbortError' ? failure.message : t('submit_error'); error.hidden = false; focus(error, false);
          } finally { pending = false; submit.disabled = false; submit.textContent = t(kind === 'waitlist' ? 'submit_waitlist' : kind === 'tutor' ? 'send_application' : 'send_enquiry'); }
        });
        return append(document.createDocumentFragment(), breadcrumb(course), append(element('div', 'ps-a-form-layout'), introBox, form));
      }
      function bookingPage(course, session) {
        if (!canBook(course, session)) return formsPage('waitlist', course, session);
        const fragment = document.createDocumentFragment();
        const intro = append(element('div'), imageNode(course.image, course.imageAlt, 'ps-a-booking-image', course.imagePosition, true), element('h3', 'ps-a-booking-heading', course.title), element('p', 'ps-a-muted', t('with_tutor', { name: course.tutorName })), element('p', 'ps-a-intro', session.displayDate), element('p', 'ps-a-muted', session.time), element('p', 'ps-a-muted', course.location));
        const form = element('form', 'ps-a-form ps-a-panel');
        if (preview) form.append(note(t('preview_booking_note')));
        const quantity = field(form, t('places'), 'quantity', 'select', true);
        const max = preview && Number.isInteger(session.placesLeft) ? Math.min(20, Math.max(1, session.placesLeft)) : 20;
        for (let count = 1; count <= max; count += 1) { const option = element('option', '', String(count)); option.value = String(count); quantity.append(option); }
        const offered = friendAvailable(course, session);
        if (offered && max >= 2) {
          const friend = append(element('div', 'ps-a-friend'), element('strong', '', t('friend_title')), element('p', '', t('friend_copy')), append(element('div', 'ps-a-actions'), button(t('friend_button'), () => { quantity.value = '2'; updateTotals(); }, true)));
          form.append(friend);
        }
        const totals = element('div', 'ps-a-summary'); totals.setAttribute('aria-live', 'polite');
        function updateTotals() {
          const count = Number(quantity.value);
          const subtotal = Math.round(course.price * 100) * count;
          const saving = offered && count >= 2 ? Math.round(subtotal * .1) : 0;
          const summaryRow = (label, amount, total = false) => append(element('div', 'ps-a-summary-row' + (total ? ' ps-a-total' : '')), element('span', '', label), element('strong', '', money(amount / 100)));
          totals.replaceChildren(summaryRow(t('subtotal'), subtotal));
          if (saving) totals.append(summaryRow(t('friend_saving'), -saving));
          totals.append(summaryRow(t('total'), subtotal - saving, true));
        }
        quantity.addEventListener('change', updateTotals); updateTotals(); form.append(totals);
        if (course.bookingTerms) { form.append(details(t('terms'), prose(course.bookingTerms))); checkbox(form, t('terms_required'), 'terms'); }
        if (!preview) form.append(element('p', 'ps-a-muted', t('booking_reminders')));
        const error = element('p', 'ps-a-error'); error.setAttribute('role', 'alert'); error.hidden = true;
        const submit = element('button', 'ps-a-button', t(preview ? 'preview_complete' : 'checkout')); submit.type = 'submit';
        submit.disabled = !preview && !catalog.csrfToken;
        append(form, error, submit, element('p', 'ps-a-muted', t('price_note')));
        let pending = false;
        form.addEventListener('submit', async event => {
          event.preventDefault(); if (pending || !form.reportValidity()) return;
          error.hidden = true;
          if (preview) {
            const result = append(element('div', 'ps-a-success'), element('h3', '', t('preview_complete')), element('p', '', t('preview_complete_copy')), totals, append(element('div', 'ps-a-actions'), link(t('continue_browsing'), '#courses', 'ps-a-button')));
            form.replaceChildren(result); focus(result.querySelector('h3')); return;
          }
          if (!catalog.bookingsEnabled || !catalog.csrfToken) return;
          pending = true; submit.disabled = true; submit.textContent = t('checking');
          try {
            const count = Number(quantity.value);
            const response = await api('/checkout', { course: course.slug, session: session.id, quantity: count, expectedPrice: course.price, friendOffer: offered && count >= 2, csrfToken: catalog.csrfToken });
            const destination = safeUrl(response.url);
            const host = str(catalog.checkoutHost).toLowerCase();
            const approvedHost = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(host) ? host : null;
            if (!destination || ![window.location.hostname, approvedHost].filter(Boolean).includes(destination.hostname) || !/^\/(?:cart\/|checkouts?\/)/.test(destination.pathname)) throw new Error(t('checkout_error'));
            window.location.assign(destination.href);
          } catch (failure) { error.textContent = failure instanceof Error && failure.name !== 'AbortError' ? failure.message : t('checkout_error'); error.hidden = false; focus(error, false); }
          finally { pending = false; submit.disabled = false; submit.textContent = t('checkout'); }
        });
        append(fragment, breadcrumb(course), heading(t('booking_title')), append(element('div', 'ps-a-form-layout'), intro, form));
        return fragment;
      }
      function giftsPage() {
        const content = append(element('div', 'ps-a-section'), heading(t('gift_title'), t('gift_eyebrow')), element('p', 'ps-a-intro', t('gift_copy')));
        const url = safeUrl(root.dataset.giftUrl || catalog.giftVoucherUrl);
        if (!preview && url && (url.hostname === window.location.hostname || /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(url.hostname))) content.append(append(element('div', 'ps-a-actions'), link(t('gift_shop'), url.href, 'ps-a-button')));
        else append(content, element('p', 'ps-a-intro', t(preview ? 'gift_preview' : 'gift_pending')), append(element('div', 'ps-a-actions'), link(t('send_enquiry'), '#private', 'ps-a-button')));
        return content;
      }
      function render(focusPage = true) {
        if (!catalog) return;
        let parts;
        try { parts = window.location.hash.slice(1).split('/').map(decodeURIComponent); } catch { parts = []; }
        const [name, slug, sessionId] = parts;
        let content;
        if (!name || ['academy', 'courses', 'tutors'].includes(name)) content = home();
        else if (name === 'course') { const course = courseBySlug(slug); if (course) content = coursePage(course); }
        else if (name === 'tutor') { const tutor = tutorBySlug(slug); if (tutor) content = tutorPage(tutor); }
        else if (name === 'book' || name === 'waitlist') {
          const course = courseBySlug(slug);
          const session = course && rows(course.sessions).find(item => item.id === sessionId);
          if (course && (session || (name === 'waitlist' && !sessionId))) content = name === 'book' ? bookingPage(course, session) : formsPage('waitlist', course, session);
        } else if (name === 'private' || name === 'teach') content = formsPage(name === 'teach' ? 'tutor' : 'private');
        else if (name === 'gifts') content = giftsPage();
        if (!content) content = append(element('div', 'ps-a-section'), heading(t('not_found')), link(t('back_home'), '#academy', 'ps-a-button'));
        view.replaceChildren(content); view.setAttribute('aria-busy', 'false');
        if (focusPage) {
          const target = ['courses', 'tutors'].includes(name) ? view.querySelector('[data-focus="' + name + '"]') : view.querySelector('h2');
          focus(target);
        }
      }
      async function load() {
        view.setAttribute('aria-busy', 'true');
        try {
          const data = preview ? JSON.parse(root.querySelector('[data-academy-preview]').textContent) : await api('/catalog');
          if (!data || !Array.isArray(data.courses) || !Array.isArray(data.tutors)) throw new Error(t('load_error'));
          catalog = { ...data, courses: data.courses.filter(course => course && typeof course.slug === 'string' && typeof course.price === 'number' && Number.isFinite(course.price) && course.price >= 0 && !['draft', 'archived'].includes(course.status)), tutors: data.tutors.filter(tutor => tutor && typeof tutor.slug === 'string') };
          render(Boolean(window.location.hash));
        } catch {
          if (controller.signal.aborted) return;
          const error = element('p', 'ps-a-status', t('load_error')); error.setAttribute('role', 'alert');
          view.replaceChildren(error, button(t('retry'), load)); view.setAttribute('aria-busy', 'false');
        }
      }
      window.addEventListener('hashchange', () => render(true), { signal: controller.signal });
      load();
    }
    document.querySelectorAll('[data-ps-academy]').forEach(initialise);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ps-academy]').forEach(initialise));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ps-academy]').forEach(root => { mounted.get(root)?.abort(); mounted.delete(root); }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
